import { createRouter, createWebHistory } from "vue-router";
import store from "@/store";
import { ElMessage } from "element-plus";

const routes = [
  {
    path: "/",
    component: () => import("../views/index.vue"),
    meta: { requireAuth: true },
    children: [
      {
        path: "",
        name: "home",
        component: () => import("../views/home.vue"),
      },
      {
        path: "/user",
        name: "user",
        component: () => import("../views/user/index.vue"),
      },
      {
        path: "/user/create",
        name: "user-create",
        component: () => import("../views/user/create.vue"),
      },
      {
        path: "/user/:id",
        name: "user-id",
        component: () => import("../views/user/_id.vue"),
      },
      {
        path: "/member",
        name: "member",
        component: () => import("../views/member/index.vue"),
      },
      {
        path: "/member/:id",
        name: "member-info",
        component: () => import("../views/member/_id.vue"),
      },
      {
        path: "/setting/domain",
        name: "setting-domain",
        component: () => import("../views/setting/domain/index.vue"),
      },
      {
        path: "/setting/domain/create",
        name: "setting-domain-create",
        component: () => import("../views/setting/domain/create.vue"),
      },
      {
        path: "/setting/domain/:id",
        name: "setting-domain-edit",
        component: () => import("../views/setting/domain/_id.vue"),
      },
      {
        path: "/setting/log",
        name: "setting-log",
        component: () => import("../views/setting/log.vue"),
      },
      {
        path: "/setting/profile",
        name: "setting-profile",
        component: () => import("../views/setting/profile.vue"),
      },
    ],
  },
  {
    path: "/YWxscG93ZXI",
    component: () => import("../views/auth/admin_login.vue"),
    name: "YWxscG93ZXI",
  },
  // EIP登入
  {
    path: "/redirect",
    component: () => import("../views/auth/_redirect.vue"),
  },
  // isso
  {
    path: "/isso_login",
    component: () => import("../views/auth/isso.vue"),
    name:'isso'
  },
  {
    path: "/login",
    component: () => import("../views/auth/login.vue"),
    name: "login",
  },
  {
    path: "/login/taipeiCardSetEmail",
    component: () => import("../views/auth/taipeiCardSetEmail.vue"),
    name: "taipeiCardSetEmail",
  },
  {
    path: "/login/verifyEmail",
    component: () => import("../views/auth/verifyEmail.vue"),
    name: "verifyEmail",
  },
  {
    path: "/verify",
    component: () => import("../views/auth/verify.vue"),
    name: "verify",
  },

  {
    path: "/error",
    component: () => import("../views/error.vue"),
    name: "error",
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由守衛
router.beforeEach((to, from, next) => {
  // console.log('beforeEach', to.name);
  let isLogin = store.getters["auth/isAuthenticated"];
  // let roles = JSON.parse(localStorage.getItem("AC_userdata")).roles;
  // console.log('current roles', roles);

  if (to.matched.some((m) => m.meta.requireAuth)) {
    if (!isLogin) {
      ElMessage.error("請重新登入");
      next("/YWxscG93ZXI");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
